module.exports = __webpack_public_path__ + "static/media/Budgets_White_Rounded.cbb17813.png";